// extracted by mini-css-extract-plugin
export default {"wrapper":"multichiplist_wrapper__8cimD"};